import { useBlocker } from '@tanstack/react-router';
import { useCallback, useRef } from 'react';

/**
 * 작성 중인 글을 두고 나가려 하면 한 번 묻는다 — 머리의 「< 아티클」 꺾쇠, 취소 버튼,
 * 브라우저 뒤로가기, 탭 닫기·새로고침 전부.
 *
 * 저장에 성공해 스스로 나가는 길(등록 → 상세)은 묻지 않아야 한다. 그 직전에 돌려받은
 * `allowLeave()` 를 부른다.
 */
export function useLeaveGuard(dirty: boolean): () => void {
  const leaving = useRef(false);
  useBlocker({
    shouldBlockFn: () => {
      if (leaving.current || !dirty) return false;
      return !window.confirm('작성 중인 내용이 저장되지 않아요. 나갈까요?');
    },
    enableBeforeUnload: () => dirty && !leaving.current,
  });
  return useCallback(() => {
    leaving.current = true;
  }, []);
}
